import { Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Observable } from "rxjs";
import { AccountService } from "@modules/account/services/account.service";
import { KycFmaModel } from "@modules/kyc/domain/entities/kyc-fma-model";
import { map, take } from "rxjs/operators";
import { parseApiObject } from "@helpers/functions";
import { ModalService } from "@core-services/modal.service";
import { KycModalComponent } from "../components/kyc-modal/kyc-modal.component";

@Injectable({
	providedIn: "root"
})
export class KycService {
	constructor(
		private apicallService: ApicallService,
		private accountService: AccountService,
		private modalService: ModalService
	) {}

	public showKycDashboardBanner(): Observable<boolean> {
		return this.accountService.accountUpdated.pipe(
			map((a) => {
				const now = Date.now();
				return (
					!!(a.getReviewStartsDays() && a.getReviewEndsDays()) &&
					a.getReviewPeriodStart().getUnix() <= now &&
					now <= a.getReviewPeriodEnd().getUnix()
				);
			})
		);
	}

	public confirmUserData(): Observable<KycFmaModel> {
		const a = new ApicallOption(null);
		return this.apicallService
			.post("user/kyc-data/confirm", a)
			.pipe(map((kycFma) => parseApiObject<KycFmaModel>(kycFma)));
	}

	public removeReviewDate(): void {
		const a = this.accountService.account;
		a.removeReviewDate();
		this.accountService.account = a;
	}

	public shouldForceKycFlow$(): Observable<boolean> {
		return this.accountService.accountUpdated.pipe(map((a) => a?.shouldForceKycFlow()));
	}

	checkKycModal(): void {
		this.shouldForceKycFlow$()
			.pipe(take(1))
			.subscribe((shouldForceKycFlow) => {
				if (shouldForceKycFlow) {
					this.modalService
						.create(KycModalComponent, null, { preventBackdropDismiss: true, preventEscDismiss: true })
						.present();
				}
			});
	}
}
